<nav aria-label="breadcrumb">
	<ol class="breadcrumb mb-0 pl-0">
		<li class="breadcrumb-item"><a [href]="'/reemplazo-docente-inicio'">Reemplazo docente</a></li>
		<li class="breadcrumb-item active" aria-current="page"><a><strong>Crear</strong></a></li>
	</ol>
</nav>
<div class="row">
	<button class="boton_volver" (click)="navToInicioReemplazoDocente()" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER"><i class="bi bi-chevron-left mr-2"></i>Volver</button>
	<h1 class="centrar_contenido offset-3">Crear reemplazo docente</h1>
</div>


<!-- DETALLE CONFIGURACIÓN -->
<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Docente a reemplazar</h6>
</div>

<form class="form" [formGroup]="parametrosForm">
	<div class="row mt-5 align-items-end">
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
			<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<select id="select_anyo" class="form-control select_criterios" formControlName="anyo" [(ngModel)]="filtroAnyo" (ngModelChange)="resetearValidacion();cargarFiltros('anyo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let anyo of listaAnyo" [value]="anyo">{{anyo}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErrores['anyo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
			<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="periodo" [(ngModel)]="filtroPeriodo" (ngModelChange)="resetearValidacion();cargarFiltros('periodo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let periodo of listaPeriodo" [value]="periodo.periodoAcademicoId">{{periodo.periodoDescripcion}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback position-absolute">
					<div *ngIf="tieneErrores['periodo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-3">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
			<label class="titulo_criterios-obligatorio ml-2" *ngIf="!rolDaraCentral">(obligatorio)</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="sede" [(ngModel)]="filtroSede" (ngModelChange)="resetearValidacion();cargarFiltros('sede')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['sede'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let sede of listaSede" [value]="sede.sedeId">{{sede.descripcion}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['sede']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErrores['sede']">Campo requerido</div>
			</div>
		</div>
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">ID Sección</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="seccion" [(ngModel)]="filtroSeccion" (ngModelChange)="resetearValidacion();cargarFiltros('seccion')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['seccion'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let seccion of listaSeccion" [value]="seccion.idSeccion">{{seccion.idSeccion}}</option>
			</select>
		</div>
		<div class="col-1 centrar_iconos_botones">
			<button (click)="actualizarLista()" class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR"><i class="bi bi-search"></i></button>
		</div>
		<div class="col-1 centrar_iconos_botones">
			<button (click)="limpiarFiltros()" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" title="ELIMINAR" alt="ELIMINAR"><i class="bi bi-x"></i></button>
		</div>
	</div>
	<div class="row mt-4 align-items-end">
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">ID Docente</label>
			<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<div class="input-group">
				<mat-autocomplete #autoDocentes="matAutocomplete" [displayWith]="displayFnCodDocentes">
					<mat-option *ngFor="let docente of filteredCodDocentes | async" [value]="docente">
							{{docente?.codigo}}
					</mat-option>
				</mat-autocomplete>
				<input type="text" (keypress)="keypressNumber($event)" id="inputCodDocente" [formControl]="searchCodDocenteForm" formControlName="idDocente" [matAutocomplete]="autoDocentes" class="form-control select_criterios" placeholder="" (ngModelChange)="resetearValidacion('inputSearchCodDocente')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['idDocente'] }">
				<div *ngIf="submitted && tieneErrores['idDocente']" class="invalid-feedback">
					<div *ngIf="tieneErrores['idDocente']" class="position-absolute">Campo requerido</div>
				</div>
			</div>
		</div>
		<div class="col-4">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Nombre Docente</label>
			<div class="input-group">
				<mat-autocomplete #autoNombreDocentes="matAutocomplete" [displayWith]="displayFnNombreDocentes">
					<mat-option *ngFor="let docente of filteredNombreDocentes | async" [value]="docente">
							{{docente?.primerNombre}} {{docente?.apellidoPat}} {{docente?.apellidoMat}}
					</mat-option>
				</mat-autocomplete>
				<input type="text" id="inputNombreDocente" [formControl]="searchNombreDocenteForm" formControlName="nombreDocente" [matAutocomplete]="autoNombreDocentes" class="form-control select_criterios" placeholder="" (ngModelChange)="resetearValidacion('inputSearchNombreDocente')">
			</div>
		</div>
	</div>
</form>

<!-- TABLA -->
<div class="row mt-4 align-items-center justify-content-end mr-3">
	<div class="d-flex">
		<p class="mr-3 mb-0">Activar todos:</p>
		<td>
			<label class="switch">
				<input type="checkbox" (checked)="activarTodos" [(ngModel)]="activarTodos" (change)="toggleActivarTodos()">
				<span class="slider round"></span>
			</label>&nbsp; {{ activarTodos ? 'Si' : 'No' }}
		</td>
	</div>
</div>

<div style="margin-top: 20px;">
	<table *ngIf="renderTable" datatable [dtOptions]="dtOptions" class="row-border hover table-striped display nowrap " aria-describedby="tabla reemplazo docente">
		<thead class="header_tabla">
			<tr>
				<th class="py-2">Sede</th>
				<th class="py-2">Sigla</th>
				<th class="py-2">Asignatura</th>
				<th class="py-2">ID Sección</th>
				<th class="py-2">Sección</th>
				<th class="py-2">Jornada</th>
				<th class="py-2">Modalidad</th>
				<th class="py-2">Activar</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let seccion of listaSeccionesDocente; index as indexSeccion">
				<td class="py-0">{{ seccion.descSede }}</td>
				<td class="py-0">{{ seccion.asignaturaCodigo }}</td>
				<td class="py-0">{{ seccion.descAsignatura }}</td>
				<td class="py-0">{{ seccion.idSeccion }}</td>
				<td class="py-0">{{ seccion.seccion }}</td>
				<td class="py-0">{{ seccion.jornadaDesc }}</td>
				<td class="py-0">{{ seccion.modalidad }}</td>
				<td>
					<label class="switch">
						<input type="checkbox" (checked)="seccion.checked" [(ngModel)]="seccion.checked">
						<span class="slider round"></span>
					</label>
					<span class="pl-4">{{ seccion.checked ? 'Si' : 'No'}}</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<!-- FIN TABLA -->

<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Docente reemplazante</h6>
</div>

<div class="row mt-5 align-items-end">
	<div class="col-3">
		<form class="form" [formGroup]="reemplazoDocenteForm">
			<label class="titulo_criterios" for="exampleFormControlSelect2">ID Docente</label>
			<div class="input-group">
				<mat-autocomplete #autoDocentesReemplazo="matAutocomplete" [displayWith]="displayFnCodDocentesReemplazo">
					<mat-option *ngFor="let docente of filteredCodDocentesReemplazo | async" [value]="docente">
							{{docente?.codigo}}
					</mat-option>
				</mat-autocomplete>
				<input type="text" (ngModelChange)="resetearValidacion()" (keypress)="keypressNumber($event)" id="inputCodDocenteReemplazo" [formControl]="searchCodDocenteReemplazoForm" formControlName="idDocenteReemplazo" [matAutocomplete]="autoDocentesReemplazo" class="form-control select_criterios" placeholder="" [ngClass]="{ 'is-invalid': submitted && tieneErrores['idDocenteReemplazo'] }">
				<div *ngIf="submitted && tieneErrores['idDocenteReemplazo']" class="invalid-feedback">
					<div *ngIf="tieneErrores['idDocenteReemplazo']" class="position-absolute">Campo requerido</div>
				</div>
			</div>
		</form>
	</div>
	<div class="col-1 centrar_iconos_botones">
		<button (click)="buscarDocenteReemplazo()" class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR"><i class="bi bi-search"></i></button>
	</div>
	<div class="col-1 centrar_iconos_botones">
		<button (click)="limpiarFiltrosDocenteReemplazo()" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" title="ELIMINAR" alt="ELIMINAR"><i class="bi bi-x"></i></button>
	</div>
</div>

<div class="row mt-5" *ngIf="nombreDocenteReemplazo">
	<div class="col-3">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Nombre docente</label>
		<div class="input-group mb-0">
			<label class="docente_reemplazante">{{ nombreDocenteReemplazo }}</label>
		</div>
	</div>
	<div class="col-3">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Fecha inicio</label>
		<div class="input-group mb-0">
			<input type="date" (change)="resetearValidacion()" [(ngModel)]="fechaInicioDocenteReemplazo" class="form-control select_criterios" placeholder="11/11/2023" aria-describedby="basic-addon2" [ngClass]="{ 'is-invalid': submitted && tieneErrores['fechaInicioDocenteReemplazo'] }">
			<div *ngIf="submitted && tieneErrores['fechaInicioDocenteReemplazo']" class="invalid-feedback">
				<div *ngIf="tieneErrores['fechaInicioDocenteReemplazo']" class="position-absolute">Campo requerido</div>
			</div>
		</div>
	</div>
	<div class="col-3">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Fecha término</label>
		<div class="input-group mb-0">
			<input type="date" (change)="resetearValidacion()" [(ngModel)]="fechaFinDocenteReemplazo" class="form-control select_criterios" placeholder="11/11/2023" aria-describedby="basic-addon2" [ngClass]="{ 'is-invalid': submitted && tieneErrores['fechaFinDocenteReeemplazo'] }">
			<div *ngIf="submitted && tieneErrores['fechaFinDocenteReeemplazo']" class="invalid-feedback">
				<div *ngIf="tieneErrores['fechaFinDocenteReeemplazo']" class="position-absolute">Campo requerido</div>
			</div>
		</div>
	</div>
</div>
<!-- FIN DETALLE CONFIGURACIÓN -->

<div class="mb-5 mt-5 pb-5">
	<button (click)="navToInicioReemplazoDocente()" class="boton-secundario offset-4" data-toggle="tooltip" data-placement="top" title="CANCELAR" alt="CANCELAR">cancelar</button>
	<button (click)="crearReemplazoDocente()" class="boton-primario tamanio_minimo ml-3" data-toggle="tooltip" data-placement="top" title="CREAR" alt="CREAR">crear</button>
</div>

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
  Launch demo modal
</button>